import classNames from 'classnames'

import { FloatingTooltip } from '../../../Floating'
import { Status } from '../../../Status'
import { TableCellBase, TableEmptyCell } from '../../../Table'

import * as styles from './DocFlowCommunicationStatusCell.module.css'

function DocFlowCommunicationStatusCell({
  className,
  isLink,
  items,
  tooltip,
  value,
  ...cellProps
}) {
  const cellClassName = classNames(className, styles.cell)

  return value ? (
    <FloatingTooltip content={tooltip} disabled={!isLink}>
      <TableCellBase {...cellProps} className={cellClassName}>
        {items.map((item, index) => (
          <Status {...item} key={index} />
        ))}
      </TableCellBase>
    </FloatingTooltip>
  ) : (
    <TableEmptyCell {...cellProps} className={cellClassName} />
  )
}

export default DocFlowCommunicationStatusCell
